import { useEffect } from 'react';

import { useConversationalSearch } from '../components/navSearch/NavSearchContext';

/**
 * Turns conversational search off whenever the active content type is
 * unsupported, regardless of how that change occurred (dropdown click, prop
 * change, initial mount). Without this the toggle can remain "on" — and the
 * conversational redirect can still fire — after switching from a supported
 * content type (e.g. video) to an unsupported one (e.g. images).
 */
export function useAutoDisableConversationalSearch(
  contentType: string,
  isSearchWithAIEnabledForContentType: (contentType: string) => boolean
): void {
  const { conversationalSearchEnabled, setConversationalSearchEnabled } =
    useConversationalSearch();

  useEffect(() => {
    if (
      conversationalSearchEnabled &&
      !isSearchWithAIEnabledForContentType(contentType)
    ) {
      setConversationalSearchEnabled(false);
    }
  }, [
    contentType,
    conversationalSearchEnabled,
    isSearchWithAIEnabledForContentType,
    setConversationalSearchEnabled,
  ]);
}
